module.exports = __webpack_public_path__ + "static/team-6612ae8c91c6578b4b4d770c6841bb8e.jpg";